import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';

interface Props {
  error: unknown;
  onReset: () => void;
}

export function RouteErrorFallback({ error, onReset }: Props) {
  const navigate = useNavigate();
  const message = error instanceof Error ? error.message : 'An unexpected error occurred.';

  return (
    <div role="alert" className="flex flex-col items-center justify-center gap-4 p-8 text-center">
      <svg className="h-10 w-10 text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <div>
        <h2 className="text-lg font-semibold text-text-primary">Something went wrong</h2>
        <p className="mt-1 text-sm text-text-muted">
          An error occurred while loading this page. You can try again or navigate to another page.
        </p>
      </div>
      <details className="w-full max-w-md text-left">
        <summary className="cursor-pointer text-xs text-text-muted">Error details</summary>
        <pre className="mt-2 overflow-auto rounded bg-bg-subtle p-3 text-xs text-text-secondary">
          {message}
        </pre>
      </details>
      <div className="flex gap-3">
        <Button variant="secondary" onClick={onReset}>Try again</Button>
        <Button variant="ghost" onClick={() => navigate('/dashboard')}>Go to dashboard</Button>
      </div>
    </div>
  );
}
